import Maintenance from "./components/Maintenance";
import useMaintenance from "./hooks/useMaintenance";

export { useMaintenance };

export default Maintenance;
